import api from "./api";

export const getAll = async (params) => {
    const { data } = await api.get("/campaign-leads", { params });
    return data;
};

export const get = async (id) => {
    const { data } = await api.get(`/campaign-leads/${id}`);
    return data;
};

export const remove = async (id) => {
    const { data } = await api.delete(`/campaign-leads/${id}`);
    return data;
};

// Alias for consistency
export const deleteLead = remove;

export const getUtmSources = async () => {
    const { data } = await api.get('/campaign-leads/utm-sources');
    return data;
};
